// Sumber kebenaran TUNGGAL logika periode item rutin (harian/mingguan/bulanan).
// Dipakai bersama oleh client (section Tugas Rutin di My Dashboard) dan server
// (cron /api/cron/recurring) supaya batas periode konsisten. Tanpa dependensi
// server — aman di-import di komponen client.

import type { Recurrence } from '@/lib/types'

const H = 3600 * 1000
// Pakai zona WIB agar batas hari/minggu/bulan sesuai pengguna (bukan UTC).
const WIB = 7 * H

/**
 * Kunci periode kalender (zona WIB): dua waktu dengan kunci sama = periode yang
 * sama (belum berganti). `ms` = epoch milidetik.
 */
export function periodKey(rec: Recurrence | string, ms: number): string {
  const d = new Date(ms + WIB)
  if (rec === 'monthly') return `m${d.getUTCFullYear()}-${d.getUTCMonth()}`
  if (rec === 'weekly') return `w${Math.floor((ms + WIB) / (7 * 24 * H))}`
  return `d${d.getUTCFullYear()}-${d.getUTCMonth()}-${d.getUTCDate()}` // daily
}

/**
 * True bila item rutin sudah diselesaikan PADA periode berjalan — yaitu
 * `tanggalSelesai` (ISO) jatuh di periode yang sama dengan `now`. Bila null atau
 * di periode lalu → false (artinya item "reset" / perlu dikerjakan lagi).
 */
export function isDoneThisPeriod(
  rec: Recurrence | string,
  tanggalSelesai: string | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!tanggalSelesai) return false
  const t = new Date(tanggalSelesai).getTime()
  if (Number.isNaN(t)) return false
  return periodKey(rec, t) === periodKey(rec, now)
}
